import React from "react";
import { string } from "prop-types";
import YouTubeVideo from "@insightfulscience/atomic-react/YouTubeVideo";
import YouTubeVideoEmbedComponent from "@insightfulscience/atomic-react/YouTubeVideo/Embed";
import { PostElementVideo } from "@insightfulscience/atomic-react/PostElement";

const YouTubeVideoEmbed = ({ title = "", caption = "", url }) => {
	const youtubeObject = url.match(
		/(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i,
	);
	return youtubeObject ? (
		<PostElementVideo caption={caption}>
			<YouTubeVideo>
				<YouTubeVideoEmbedComponent id={youtubeObject[1]} title={title} />
			</YouTubeVideo>
		</PostElementVideo>
	) : null;
};

YouTubeVideoEmbed.propTypes = {
	title: string,
	caption: string,
	url: string.isRequired,
};

export default YouTubeVideoEmbed;
